import { useSessionStorage } from "@/helpers/useSessionStorage"
import { useUserStore } from "@/stores/user"
import { storeToRefs } from "pinia"

export const useGotoParam = () => {
  const { getSessionItem, deleteSessionItem } = useSessionStorage()

  const getGotoParam = (): string | null => {
    const originalSearchParams = new URLSearchParams(window.location.search)
    return originalSearchParams.get("goto") || getSessionItem("goto_param")
  }

  const removeGotoParam = () => {
    const { isFromInt } = storeToRefs(useUserStore())

    if (!isFromInt.value) {
      deleteSessionItem("goto_param")
    }
  }

  const isGotoParam = (value: string) => getGotoParam() === value

  return { getGotoParam, removeGotoParam, isGotoParam }
}
